<template>
  <el-dialog
    :title="'GÁN PHÒNG'"
    :visible.sync="dialogAssignRoomVisible"
    width="90%"
    :close-on-click-modal="false"
    @close="() => {}"
  >
    <div class="das-form-container datnt">
      <div class="das-form-group">
        <div class="das-form-group-title">
          {{ 'Đặt phòng đã chọn' }}
        </div>
        <!-- <div v-loading="roomLo ading" class="grid-scroll mt-10">
          <GridVx
            ref="bookingTable"
            style="height: calc(40px + 5 * 34px)"
            dom-layout="scroll"
            :columns="bookingCols"
            :rows="bookingRows"
            class="agGrid"
            :auto-size-cell="true"
            row-selection="single"
            :want-to-get-row-selected-event="true"
            :auto-select-first-row="false"
            @rowClicked="
              event => {
                bookingIndex = event.rowIndex
              }
            "
            @selectionChanged="onSelectBooking"
          />
        </div> -->
        <InfoList
          :columns="3"
          :column-breakpoint-options="{
            sm: 1,
            md: 3
          }"
        >
          <InfoListLabel style="max-width: 300px">Mã đặt phòng</InfoListLabel>

          <InfoListValue style="max-width: 300px">{{
            selectedBooking?.booking_code
          }}</InfoListValue>

          <!-- <InfoListLabel>Số xác nhận</InfoListLabel>
          <InfoListValue>{{ selectedBooking?.confirm_code }}</InfoListValue> -->

          <InfoListLabel>Hạng phòng</InfoListLabel>
          <InfoListValue>{{ selectedBooking?.room_level_nm }}</InfoListValue>

          <InfoListLabel>Phòng</InfoListLabel>
          <InfoListValue>{{ selectedBooking?.room_num }}</InfoListValue>

          <InfoListLabel>Tên khách</InfoListLabel>
          <InfoListValue>{{
            selectedBooking?.last_name &&
            selectedBooking?.first_name &&
            `${selectedBooking?.last_name} ${selectedBooking?.first_name}`
          }}</InfoListValue>

          <InfoListLabel>Ghi chú</InfoListLabel>
          <InfoListValue>{{ selectedBooking?.note }}</InfoListValue>
        </InfoList>
      </div>

      <div class="das-form-group">
        <div class="das-form-group-title">
          {{ 'Danh sách phòng trống' }}
        </div>
        <div>
          <search-comp @onSearch="fnSearchRoomList" @onReset="onReset">
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">Số phòng</div>
                      <div class="child-w-80">
                        <input
                          v-model="searchParams.roomNumber"
                          type="text"
                          placeholder="Nhập số phòng"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">Khách sạn</div>
                      <div class="child-w-80">
                        <el-select
                          v-model="searchParams.hotelId"
                          style="flex: 1"
                          placeholder="Chọn"
                        >
                          <el-option
                            v-for="(item, index) in hotelList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">Hạng phòng</div>
                      <div class="child-w-80">
                        <el-select
                          v-model="searchParams.roomLevelId"
                          style="flex: 1"
                          placeholder="Chọn"
                        >
                          <el-option
                            v-for="(item, index) in roomLevelList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">Trạng thái</div>
                      <div class="child-w-80">
                        <el-select
                          v-model="searchParams.status"
                          style="flex: 1"
                          placeholder="Chọn"
                        >
                          <el-option
                            v-for="(item, index) in statusList"
                            :key="index"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">Ngày đến</div>
                      <div class="child-w-80">
                        <CalendarSelect
                          v-model="searchParams.arriveDate"
                          style="display: block; width: 100%"
                          mode="datetime"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">Ngày đi</div>
                      <div class="child-w-80">
                        <CalendarSelect
                          v-model="searchParams.departDate"
                          style="display: block; width: 100%"
                          mode="datetime"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col col-6">
                    <div class="das-form-input">
                      <div class="label">Khác</div>
                      <div
                        style="
                          background: #f0f0f5;
                          padding: 0 8px;
                          margin: 0;
                          height: 32px;
                          display: flex;
                          align-items: center;
                          border-radius: 5px;
                        "
                      >
                        <div class="checkbox-wrap pr-1">
                          <input
                            id="searchParams.onlyAvailable"
                            v-model="searchParams.onlyAvailable"
                            type="checkbox"
                          />
                          <label for="searchParams.onlyAvailable">{{
                            'Chỉ những phòng có thể đặt'
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div></search-comp
          >
        </div>

        <div v-loading="roomLoading" class="grid-scroll mt-10">
          <GridVx
            ref="roomTable"
            style="height: calc(40px + 5 * 34px)"
            dom-layout="scroll"
            :columns="roomColumns"
            :rows="roomRows"
            row-selection="single"
            class="agGrid"
            :auto-size-cell="true"
            :auto-select-first-row="false"
            :want-to-get-row-selected-event="true"
            @rowClicked="
              event => {
                roomIndex = event.rowIndex
              }
            "
            @selectionChanged="onSelectRoom"
          />
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogAssignRoomVisible = false"
        >
          {{ 'Đóng' }}
        </button>
        <button
          class="btn primary small"
          :disabled="!selectedRoom"
          @click="onAssignRoom"
        >
          {{ 'Gán phòng' }}
        </button>
        <button class="btn primary small" @click="onRedoAssignRoom">
          {{ 'Bỏ gán phòng' }}
        </button>
        <button class="btn primary small" @click="onUpdateAssignRoom">
          {{ 'Cập nhật' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import {
  getRoomListApi,
  getHotelListApi
} from '@/api/booking_service/bookingGroup'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { assignRoom } from '@/api/reception/reception'
import { notifySuccess } from '@/utils/toast'

import * as dayjs from 'dayjs'

export default {
  components: {
    CalendarSelect,
    InfoListLabel,
    InfoListValue,
    CellRenderCheckboxReadonly
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      roomLoading: false,
      searchParams: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null,
        status: null,
        arriveDate: null,
        departDate: null,
        onlyAvailable: true
      },
      searchParamsDefault: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null,
        status: null,
        arriveDate: null,
        departDate: null,
        onlyAvailable: true
      },
      hotelList: [],
      roomLevelList: [],
      statusList: ['VD', 'VC', 'VCI', 'OD', 'OC', 'OCI', 'OOS', 'OOO'],

      // list
      roomColumns: [
        {
          headerName: 'Khách sạn',
          field: 'hotel_name'
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_name'
        },
        {
          headerName: 'Số phòng',
          field: 'room_num'
        },
        {
          headerName: 'Thuộc tính phòng',
          field: 'room_properties'
        },
        {
          headerName: 'Trạng thái buồng phòng',
          field: 'chamber_status',
          cellStyle: params => {
            const data = params.data.chamber_status
            const property = {
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: null
            }
            if (data === 'VCI' || data === 'OCI') {
              // checked
              property.backgroundColor = '#c3edd9'
              property.color = '#357456'
            } else if (data === 'VD' || data === 'OD') {
              // dirty
              property.backgroundColor = '#ffdfe1'
              property.color = '#f12b37'
            } else if (data === 'OOS' || data === 'OOO') {
              property.backgroundColor = '#cdcccc'
              property.color = '#575757'
            } else {
              // clean
              property.backgroundColor = '#ffecd5'
              property.color = '#ea7e00'
            }
            return property
          }
        },
        {
          headerName: 'Bị chiếm',
          field: 'rep_status',
          cellClass: 'grid-cell-align-center',
          width: 100,
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      roomRows: [],
      selectedRoom: null,
      roomIndex: null,

      selectedBooking: null
    }
  },
  computed: {
    dialogAssignRoomVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.selectedBooking = { ...this.data }
        this.$emit('input', val)
      }
    }
  },
  watch: {
    data(nv, ov) {
      if (nv) {
        if (!this.data.recode) {
          return
        }
        this.selectedBooking = { ...nv }
        // console.log(this.selectedBooking)
        // this.searchParams.arriveDate = this.data?.arrive_date
        //   .split('.')[0]
        //   .slice(0, -3)
        // this.searchParams.departDate = this.data?.depart_date
        //   .split('.')[0]
        //   .slice(0, -3)
        // this.searchParams.roomLevelId = this.data?.room_level_id

        this.searchParamsDefault.arriveDate = dayjs(
          this.data.arrive_date,
          'DD-MM-YYYY HH:mm:ss'
        ).format('YYYY-MM-DD HH:mm')
        this.searchParamsDefault.departDate = dayjs(
          this.data.depart_date,
          'DD-MM-YYYY HH:mm:ss'
        ).format('YYYY-MM-DD HH:mm')
        this.searchParams = { ...this.searchParamsDefault }
        this.searchParams.roomLevelId = this.data.room_level_id

        this.fnSearchRoomList()
      }
    }
  },

  mounted() {
    this.fnGetHotelListApi()
    this.getRoomLevelOptions()
    this.fnSearchRoomList()
  },

  methods: {
    // handle event
    onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      this.fnSearchRoomList()
    },
    onSelectRoom(select) {
      this.selectedRoom = select[0]
      if (!this.selectedRoom) this.roomIndex = null
    },

    onAssignRoom() {
      const temp = this.selectedBooking.assignedRoom ?? null
      this.selectedBooking.room_num = this.selectedRoom.room_num
      this.selectedBooking.assignedRoom = this.selectedRoom
      this.selectedBooking.room_level_id = this.selectedRoom.room_level_id
      this.roomRows.splice(this.roomIndex, 1)
      temp ? this.roomRows.unshift(temp) : {}
    },
    onRedoAssignRoom() {
      const temp = this.selectedBooking.assignedRoom ?? null
      this.selectedBooking = { ...this.data }
      this.roomRows.unshift(temp)
    },

    async onUpdateAssignRoom() {
      const freeCard = this.roomLevelList.find(
        item => item.id == this.selectedBooking?.room_level_id
      ).free_card_quantity
      await assignRoom({
        booking_id: this.selectedBooking?.sub_booking_group_id,
        date_to: this.selectedBooking?.depart_date,
        date_from: this.selectedBooking?.arrive_date,
        room_type_id:
          this.selectedBooking?.assignedRoom?.room_level_id ||
          this.data?.room_level_id,
        room_id:
          this.selectedBooking?.assignedRoom?.room_id || this.data?.room_id,
        num_of_free_card: freeCard
      })
        .then(res => {
          if (!res.is_error) {
            notifySuccess(res?.message)
          }

          this.$emit('submit')
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.dialogAssignRoomVisible = false
        })
    },

    // handle api call
    async fnSearchRoomList() {
      // reset assgined booking:
      this.selectedBooking = { ...this.data }
      this.roomLoading = true

      await getRoomListApi(this.searchParams)
        .then(res => {
          this.roomRows = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.roomLoading = false
        })
    },
    async fnGetHotelListApi() {
      await getHotelListApi()
        .then(res => {
          this.hotelList = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    }
  }
}
</script>

<style lang="scss" scoped>
.das-form-container.datnt > * + * {
  margin: 2rem 0;
}
</style>
